export enum BankValidityEnum {
	VALID = 'S',
	INVALID = 'N',
}

export type GetValidateBankParams = {
	bankCode: string;
	agencyCode: string;
	signal?: AbortSignal;
};

export type GetValidateBankResponse = {
	content: {
		bankCode: string;
		agencyCode: string;
		isValid: BankValidityEnum;
	};
	notifications: string[];
};

export interface GetValidateBank {
	get: (params: GetValidateBankParams) => Promise<GetValidateBankResponse>;
}
